import React from 'react';
import STRINGS from './../../data/language/language';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Modal from '../../components/modal.v2/Modal';
const URL = WS.facebook.participar;

export default class MsgFbGoup extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      nome: '',
      strings: STRINGS[window.LANGUAGE],
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.callMsgFb = this.callMsgFb.bind(this);
  }

  callMsgFb(e){
    e.preventDefault();
    const lang = this.state.strings;
    const { nome } = this.state;

    if(!nome){
      var msg = {
        title: lang.atencao,
        text: lang.nomeFbGroup
      };
      Dialog.create(msg);
      return false;
    }

    const link = this.props.link;

    //-------
    Requisitions({
      url: URL,
      data:{ nome },
      sucess:function(data){
        var msg = {
          title: lang.atencao,
          text: data.msg,
          onSubmit: () => {
            window.open(link,"_blank");
            Dialog.destroy();
            Modal.destroy();
          }
        };
        Dialog.create(msg);
      },
      error:function(data){
        console.log(data);
      }
    });

  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

  }

  render(){
    const lang = this.state.strings;

    return(
      <div>
        <p>{lang.fb6}</p>
        <br />
        <TextInput
          value={this.state.nome}
          onChange={this.handleInputChange}
          name="nome"
          title={`${lang.txtNomeFbUser}*`}
          placeholder={lang.digiteUsuario}>
        </TextInput>
        {/*<p>{lang.hello}</p>
        <br />
        <p>{lang.fb1}</p>
        <br /><br />
        <strong>{lang.fb2}</strong>
        <br /><br />
        <p>{lang.fb3}</p>
        <br />
        <p>{lang.fb4}</p>
        <br />
        <p>{lang.fb5}</p>*/}
        <br />
        <br />
        <p className='box-bt-group'><a className='bt-fb-group' href='#' onClick={this.callMsgFb}><span className='link-menu--txt'>{lang.queroParticipar}</span></a></p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/menu/MsgFbGoup.js